import {styled, theme} from "@reside/ui";

/** Design: track width ~2.5–3x height, thumb diameter slightly less than track height */
const TRACK_HEIGHT = 26;
const THUMB_SIZE = 14;
const TRACK_WIDTH = 58;

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[3]}px;
`;

export const SwitchTrack = styled.div<{
  $checked: boolean;
  $error: boolean;
  $disabled: boolean;
}>`
  width: ${TRACK_WIDTH}px;
  height: ${TRACK_HEIGHT}px;
  border-radius: ${TRACK_HEIGHT / 2}px;
  display: flex;
  flex-direction: ${({$checked}) => ($checked ? "row-reverse" : "row")};
  align-items: center;
  padding: 5px;
  box-sizing: border-box;
  cursor: ${({$disabled}) => ($disabled ? "not-allowed" : "pointer")};
  opacity: ${({$disabled}) => ($disabled ? 0.6 : 1)};
  transition: background-color 0.2s ease, flex-direction 0.2s ease;

  /* Track: light desaturated blue-grey; subtle border */
  background-color: ${({$checked, theme}) =>
    $checked ? theme.color.lightBlue10 : theme.color.gray10};
  border: 2px solid
    ${({$checked, $error, theme}) =>
      $error
        ? theme.color.errorRed
        : $checked
        ? theme.color.primary
        : theme.color.gray100};
`;

export const SwitchThumb = styled.div<{$checked: boolean; $disabled: boolean}>`
  width: ${THUMB_SIZE}px;
  height: ${THUMB_SIZE}px;
  min-width: ${THUMB_SIZE}px;
  border-radius: 50%;
  flex-shrink: 0;
  transition: background-color 0.2s ease;

  /* Thumb: medium blue-grey (OFF) or primary (ON); subtle border */
  background-color: ${({$checked, theme}) =>
    $checked ? theme.color.primary : theme.color.gray100};
`;

export const SwitchText = styled.span<{$checked: boolean; $disabled: boolean}>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${theme.fontSize[1]}px;
  font-weight: ${theme.fontWeight.bold};
  text-transform: uppercase;
  letter-spacing: 0.02em;

  /* OFF: medium blue-grey on grey track; ON: dark blue on light blue track */
  color: ${({$checked, theme}) =>
    $checked ? theme.color.primary : theme.color.gray100};
`;

export const SwitchLabel = styled.span<{$error: boolean}>`
  font-size: ${theme.fontSize[3]}px;
  color: ${({$error, theme}) =>
    $error ? theme.color.errorRed : theme.color.darkBlue100};
`;
